angular.module("vgresiduos").directive("destinationConfirmation", function () {
	return {
		scope: true,
		controller: "DestinationConfirmationCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/stages/destinationConfirmation/destinationConfirmation_template.html"
	};
});
